import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./app.css";
import Home, { LANGS } from "./pages/home/home";
import PAGES from "./pages/home/pages.json";

/* "/" → language from the browser (uz → /uz, otherwise /ru) */
const detectLang = () => {
    const nav = (typeof navigator !== "undefined" && (navigator.language || "")).toLowerCase();
    return nav.startsWith("uz") ? "uz" : "ru";
};

/* Scroll to top when the page changes, but keep the position when only the language changes */
const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    const prev = useRef(pathname);

    useEffect(() => {
        const stripLang = (p) => p.replace(/^\/(ru|uz|en)(?=\/|$)/, "");
        if (!hash && stripLang(prev.current) !== stripLang(pathname)) {
            window.scrollTo(0, 0);
        }
        prev.current = pathname;
    }, [pathname, hash]);

    return null;
};

const App = () => (
    <section className="app-screen">
        <ScrollManager />
        <Routes>
            <Route path="/" element={<Navigate to={`/${detectLang()}`} replace />} />

            {/* /ru, /ru/gps, /uz/gps-nukus, /en/hikvision ... */}
            {LANGS.map((lang) =>
                PAGES.map((p) => (
                    <Route
                        key={`${lang}-${p.key}`}
                        path={`/${lang}${p.slug ? `/${p.slug}` : ""}`}
                        element={<Home lang={lang} page={p.key} />}
                    />
                ))
            )}

            {/* old links without a language (/gps, /hikvision ...) → Russian version */}
            {PAGES.filter((p) => p.slug).map((p) => (
                <Route key={`legacy-${p.key}`} path={`/${p.slug}`} element={<Navigate to={`/ru/${p.slug}`} replace />} />
            ))}

            <Route path="*" element={<Navigate to="/ru" replace />} />
        </Routes>
    </section>
);

export default App;
